import Backbone from 'backbone';
import { isUndefined } from 'underscore';
import editorEventHandler from '../../studioPlugins/editorEventHandler';

export default Backbone.Model.extend({
  defaults: {
    type: 'text', // text, number, range, select
    label: '',
    name: '',
    min: '',
    max: '',
    unit: '',
    step: 1,
    value: '',
    target: '',
    default: '',
    className: '',
    visible: true,
    placeholder: '',
    changeProp: 0,
    unique: false,
    isValid: true,
    options: [],
    conditions: [],
    requires: []
  },

  initialize() {
    const target = this.get('target');
    const name = this.get('name');
    const changeProp = this.get('changeProp');

    if (target) {
      this.target = target;
      this.unset('target');
      const targetEvent = changeProp
        ? `change:${name}`
        : `change:attributes:${name}`;
      this.listenTo(target, targetEvent, this.targetUpdated);
    }
  },

  /**
   * Return all the propeties
   * @returns {Object}
   */
  props() {
    return this.attributes;
  },

  targetUpdated() {
    const value = this.getTargetValue();
    this.set({ value }, { fromTarget: 1 });
  },

  getTargetValue() {
    const name = this.get('name');
    const target = this.target;
    let value;

    if (this.get('changeProp')) {
      value = target.get(name);
    } else {
      value = target.getAttributes()[name];
    }

    return !isUndefined(value) ? value : '';
  },

  setTargetValue(value, opts = {}) {
    const target = this.target;
    const name = this.get('name');
    if (isUndefined(value)) return;
    if (this.get('changeProp')) {
      target.set(name, value, opts);
    } else {
      const attrs = { ...target.get('attributes') };
      attrs[name] = value;
      target.set('attributes', attrs, opts);
      this.validateTrait();
      this.collection.isValid() && this.specialCharacterTest(value)
        ? $('#gjs').removeClass('restrict')
        : $('#gjs').addClass('restrict');
    }
  },

  specialCharacterTest(value) {
    return !/[$&+,:;=\\\?@#|\/'<>.^*()%!-]/g.test(value);
  },

  setValueFromInput(value, final = 1, opts = {}) {
    const toSet = { value };
    this.set(toSet, { ...opts, avoidStore: 1 });

    // Have to trigger the change
    if (final) {
      this.set('value', '', opts);
      this.set(toSet, opts);
    }
  },

  /**
   * Get the initial value of the trait
   * @return {string}
   */
  getInitValue() {
    const target = this.target;
    const name = this.get('name');
    let value;

    if (target) {
      const attrs = target.get('attributes');
      value = this.get('changeProp') ? target.get(name) : attrs[name];
    }

    return value || this.get('value') || this.get('default');
  },

  validateTrait() {
    var value = this.get('value');
    var requires = this.get('requires');
    if (value && requires.length) {
      this.collection.models.forEach(function(model) {
        if (requires.indexOf(model.get('name')) > -1) {
          model.get('value')
            ? model.validateUnique()
            : model.set('isValid', false);
        }
      });
    } else if (requires.length) {
      /// if value for a trait is false  then dependent traits are valid.
      this.set('isValid', true);
      this.collection.models.forEach(function(model) {
        if (requires.indexOf(model.get('name')) > -1) {
          model.set('isValid', true);
        }
      });
    } else {
      this.set('isValid', true);
      this.collection.validateTraitsWithDependency();
    }
  },

  validateUnique() {
    if (this.get('unique')) {
      let name = this.get('name');
      let value = this.get('value');
      let blocksFound = $(editor.getHtml()).find(`[${name}="${value}"]`).length;
      blocksFound > 1 ? this.set('isValid', false) : this.set('isValid', true);
    } else {
      this.set('isValid', true);
    }
  },

  executeCondition() {
    const conditions = this.get('conditions');
    conditions.forEach(function(con) {
      var result = this.evaluateCondition(con.condition);
      this.performOperation(con[result], con.target);
    }, this);
  },

  evaluateCondition(con) {
    var cond = con.split(' ');
    var op = cond[0];
    var value = cond[1] || '';
    switch (op) {
      case '$eq':
        return this.get('value').toString() == value;
        break;
      default:
        return false;
        break;
    }
  },

  performOperation(result, target) {
    if (result) {
      switch (result.op) {
        case 'set':
          var value = result.value === false ? false : result.value || '';
          this.collection.models.forEach(function(model) {
            if (target.indexOf(model.get('name')) > -1) {
              model.set('value', value, { fromCondition: 1 });
            }
          });
          break;
        case 'show':
          this.collection.models.forEach(function(model) {
            if (target.indexOf(model.get('name')) > -1) {
              model.set('visible', true);
            }
          });
          break;
        case 'hide':
          this.collection.models.forEach(function(model) {
            if (target.indexOf(model.get('name')) > -1) {
              model.set('visible', false);
            }
          });
          break;
      }
    }
  }
});
